module.exports = __webpack_public_path__ + "img/38.183a7488.png";